import { values, orderBy, groupBy } from 'lodash';

export function videoLectures(state) {
  return state.videoLectures;
}

export function videoLectureList(state) {
  return orderBy(values(state.videoLectures), ['created_at'], ['desc']);
}

export function lecturesByCourseId(state) {
  return groupBy(state.videoLectures, 'video_course_id');
}

export function recentVideoUploadInfo(state) {
  return state.recentVideoUploadInfo;
}



// WEBPACK FOOTER //
// ./src/app/video-lectures/store/getters.js